import markSuccess from './mark-success.json';

export const animations = {
  markSuccess,
};
